import {inject, ref, Ref, watch} from "vue";
import {injectRegisterFormValidateHooks} from "/@src/constants/keys";
import {useI18n} from "vue-i18n";
import {FormValidatorRule} from "/@src/components/custom/form/BaseForm.vue";

export const useFormValidateRules = (value:Ref<any>,field:string,rule?:FormValidatorRule) => {
  const message = ref('')
  const {t} = useI18n()
  const registerValidator = inject(injectRegisterFormValidateHooks)
  if (rule){
    const excuteHook = () => {
      return Promise.resolve(validate())
    }
    // 注册给整体form校验，当表单提交时触发
    registerValidator?.(excuteHook)
  }
  // 默认为change类型触发
  if (!rule?.trigger || rule?.trigger.includes('change')){
    watch(value,(newValue)=>{
      if (validate(newValue)){
        message.value = ''
      }
    },{immediate:rule?.trigger?.includes('init')})
  }
  function validate (checkValue?:any):boolean {
    if (!rule){
      return true
    }
    const valueToCheck = checkValue||value.value
    if (rule.validator){
      Promise.resolve(rule.validator(field, valueToCheck)).catch(err => message.value = err.message)
      return true
    }
    if (rule.required && !valueToCheck){
      message.value = rule.message||t('form-validate-required')
      return false
    }
    if (valueToCheck && (typeof valueToCheck === 'string' || valueToCheck instanceof String)){
      if(rule.limit !== undefined && rule.limit > 0 && valueToCheck.length > rule.limit) {
        message.value = rule.message || t('form-validate-limit')
        return false
      }
    }
    return true
  }
  return {
    message,
    validate
  }
}
